import { StoreType, ViewModeType } from 'store_constants/types';

export const KREMEN_RETAILER = {
    storage_key: 'kb_ua-ws',
    active: true,
    required_registration: false,
    URL: ['https://kremen-belts.com'],
    web_lang: 'uk', // html lang
    store_name: 'Kremen Belts Store',
    store_code: 'DEFAULT',
    base_url: 'https://kremen-belts.com/api',
    app_lang: 'ua',
    supported_countries: [{ code: 'UA', country: 'ukraine' }],
    telegram_sender: true,
    links: [
        // {
        //     name: 'Kremen Belts Sales',
        //     href: 'https://kremen-belts-sales.netlify.app/store',
        //     description: 'Sales',
        //     type: 'WEB',
        // },
    ],
    managers: null,
    options: {
        telegram_bot: [
            {
                token: '7115237316:AAFgbrVadLWMkPt3TEdmravEa37jO9N3WSQ',
                chatId: '480774886',
            },
        ],
        product_image_options: { width: 4, height: 3 },
        main_price_multiplication: 1,
        sale_price_multiplication: 3.5,
        currency_multiplication: 40,
        retail_price_multiplication: 1,
        custom_currency: '₴',
        min_items_to_buy: 1,
        store_type: StoreType?.sales,
        home_page_active: false,
        informative_page_active: false,
        custom_logo: false,
        plan_options: {
            prices: true,
            sizes: false,
            contacts: true,
            feedback: false,
            categories: true,
            productShare: true,
            cart: true,
            favorites: true,
            tableSizes: false,
        },
    },
    web_head_data: {
        store_title: 'Kremen Belts Wholesales Catalog | Kremen Belts Оптовий Каталог',
        store_description: `Ласкаво просимо до Kremen Belts — вашого найкращого джерела стильних ременів та аксесуарів! | Welcome to Kremen Belts — your ultimate source for stylish belts and accessories!`,
        google_analytics_id: 'G-7G98583PY1',
        google_ads_id: '',
        conversion_id: '',
        store_logo: 'kremen_belts_logo.png',
        store_poster: 'belts.jpeg',
        keywords: {},
    },
    user_options: { view_mode: ViewModeType?.card },
    alerts: [],
};
